<div class="sparkline">
  <div *ngIf="areAllKeyValuesNull | wrapFn: data : 'value'" class="no-data">
    {{"charts.no-data" | translate}}
  </div>
  <apx-chart
    [series]="chartOptions.series!"
    [chart]="chartOptions.chart!"
    [xaxis]="chartOptions.xaxis!"
    [yaxis]="chartOptions.yaxis!"
    [dataLabels]="chartOptions.dataLabels!"
    [grid]="chartOptions.grid!"
    [stroke]="chartOptions.stroke!"
    [tooltip]="chartOptions.tooltip"
    [markers]="chartOptions.markers"
    [legend]="chartOptions.legend!"
  ></apx-chart>
</div>
